module.exports = {"id":"212602","name":"Diego Llorente","rating":"79","photo":"./data/images/photos/1/212602.png","club":{"name":"Real Sociedad","logo":"./data/images/clubs/RealSociedad.png"},"positions":["DC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoLlorente0.json
// module id = 1087
// module chunks = 0